"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleSearchFileTable = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var http_status_codes_1 = require("http-status-codes");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var file_table_1 = require("../../components/file-table");
var search_pagination_1 = require("../../components/search-pagination");
var use_archive_file_1 = require("../../hooks/use-archive-file");
var use_download_file_1 = require("../../hooks/use-download-file");
var use_files_api_1 = require("../../hooks/use-files-api");
var use_google_search_1 = require("../../hooks/use-google-search");
var use_is_producer_1 = require("../../hooks/use-is-producer");
var use_unarchive_file_1 = require("../../hooks/use-unarchive-file");
var enrich_file_results_with_associations_1 = require("../../lib/enrich-file-results-with-associations");
var google_search_fetch_associations_map_1 = require("../../lib/google-search-fetch-associations-map");
var google_search_filter_options_1 = require("../../lib/google-search-filter-options");
var google_search_format_file_results_1 = require("../../lib/google-search-format-file-results");
var files_auth_provider_1 = require("../../providers/files-auth-provider");
var google_search_1 = require("../../providers/google-search");
var DEBOUNCE_MS = 300;
var GOOGLE_SEARCH_SEARCH_INPUT = 'google_search_input';
function GoogleSearchFileTable(_a) {
    var documentTypes = _a.documentTypes, domainObjectReference = _a.domainObjectReference, fileStatus = _a.fileStatus, maxPages = _a.maxPages, _b = _a.resultsPerPage, resultsPerPage = _b === void 0 ? 10 : _b, uploadRoute = _a.uploadRoute;
    var documentTypeValues = documentTypes === null || documentTypes === void 0 ? void 0 : documentTypes.split(','); // Many documentTypes can be received from query string params
    // how should we filter cloud search results?
    // if a domainObject isnt provided e.g. domainObjectReference={{ client: [clientUuid as string] }}
    // return all files
    var cloudSearchFilterOptions = (0, google_search_filter_options_1.formatToCloudSearchFilterOption)(domainObjectReference);
    // refs
    var searchInputRef = (0, react_1.useRef)(null);
    var searchContainerRef = (0, react_1.useRef)(null);
    // hooks
    var user = (0, files_auth_provider_1.useAuthProvider)().userDetails;
    var isProducer = (0, use_is_producer_1.useIsOnlyProducer)();
    var filesApi = (0, use_files_api_1.useFilesApi)();
    var downloadFile = (0, use_download_file_1.useDownloadFile)()[0];
    var archiveFile = (0, use_archive_file_1.useArchiveFile)()[0];
    var unarchiveFile = (0, use_unarchive_file_1.useUnarchiveFile)()[0];
    var _c = (0, react_1.useContext)(google_search_1.GoogleCloudSearchContext), gapiClientId = _c.gapiClientId, isGapiLoaded = _c.isGapiLoaded, googleSearchDataSourceId = _c.googleSearchDataSourceId, googleSearchApplicationId = _c.googleSearchApplicationId;
    // state
    var _d = (0, react_1.useState)(''), currentQuery = _d[0], setCurrentQuery = _d[1];
    var _e = (0, react_1.useState)(undefined), searchResults = _e[0], setSearchResults = _e[1];
    var _f = (0, react_1.useState)(0), pageCount = _f[0], setPageCount = _f[1];
    var _g = (0, react_1.useState)(0), page = _g[0], setPage = _g[1];
    var _h = (0, react_1.useState)(false), initialRenderCompleted = _h[0], setInitialRenderCompleted = _h[1];
    var _j = (0, react_1.useState)(false), fetchedAssociations = _j[0], setFetchedAssociations = _j[1];
    /**
     * handleFileDetailsChange
     * Accepts an 'updatedFile' - passed from <FileTable />
     * We locate this same file in our existing searchResults and update the summary and updatedAt attributes in the table.
     * This gives the appearance that searchResults have updated, but in reality this data change wont persist.
     * New results will need to be fetched (refreshing the app after ~30 seconds) for data to persist.
     * Clear and reset the searchResults
     */
    var handleFileDetailsChange = (0, react_1.useCallback)(function (updatedFile) {
        var _a;
        if (!updatedFile || !searchResults)
            return;
        var index = searchResults.findIndex(function (result) { return result.fileId === updatedFile.id; });
        if (index < 0)
            return;
        var updatedFoundResult = __assign(__assign({}, searchResults[index]), { summary: ((_a = updatedFile === null || updatedFile === void 0 ? void 0 : updatedFile.meta) === null || _a === void 0 ? void 0 : _a.summary) || '', updatedAt: new Date(updatedFile.updatedAt).toISOString() });
        setSearchResults([]);
        var updatedSearchResults = searchResults;
        updatedSearchResults[index] = updatedFoundResult;
        setSearchResults(updatedSearchResults);
    }, [searchResults]);
    /**
     * interceptSearchRequest
     * This callback is passed to our instantiation of the 'useGoogleCloudSearch' hook below,
     * used to create a resultsContainer.
     * This defines data sources and filter options
     */
    var interceptSearchRequest = (0, react_1.useCallback)(function (request) {
        var _a;
        if (!request.start) {
            // Reset the page when a new search is fired.
            setPage(0);
        }
        return __assign(__assign({}, request), { dataSourceRestrictions: {
                source: {
                    name: "datasources/".concat(googleSearchDataSourceId),
                },
                filterOptions: (0, google_search_filter_options_1.getSearchFilterOptions)({
                    cloudSearchFilterOptions: cloudSearchFilterOptions,
                    isProducer: isProducer,
                    userUuid: (_a = user === null || user === void 0 ? void 0 : user.uuid) !== null && _a !== void 0 ? _a : '',
                    fileStatus: fileStatus,
                    documentTypes: documentTypeValues,
                }),
            } });
    }, [googleSearchDataSourceId, isProducer, user === null || user === void 0 ? void 0 : user.uuid, fileStatus, documentTypes]);
    /**
     * interceptSearchResponse
     * This callback is passed to our instantiation of the 'useGoogleCloudSearch' hook below,
     * used to create a resultsContainer
     * Given results for a search (cloudSearchResults), we format reach result to a FileResult for our table component.
     * We set 'setFetchedAssociations' to false, and a following useEffect will listen for changes to 'fetchedAssociations'
     * and request and populate the associations for us.
     */
    var interceptSearchResponse = (0, react_1.useCallback)(function (response) {
        function setNoResults() {
            setSearchResults([]);
            setFetchedAssociations(false);
            setPageCount(0);
        }
        // If we don't have a response, it would most likely be because of configuration
        if (!response) {
            setNoResults();
            console.warn("\n      There was not response from cloudsearch.\n      Check the api keys are configured correctly and/or\n      if your port has been added to the Newfront Google Cloud Platform 'Authorized JavaScipt Origins'");
            return;
        }
        var result = response.result, status = response.status;
        var results = result.results, resultCountEstimate = result.resultCountEstimate, resultCountExact = result.resultCountExact;
        if (!results || parseInt(resultCountEstimate, 10) === 0 || status !== http_status_codes_1.StatusCodes.OK) {
            setNoResults();
        }
        else {
            var resultCount = parseInt(resultCountExact, 10) || parseInt(resultCountEstimate, 10) || 0;
            var files = (0, google_search_format_file_results_1.formatCloudResultstoFileResults)(results, archiveFile, downloadFile, unarchiveFile);
            setSearchResults(files);
            setFetchedAssociations(false);
            var count = Math.ceil(resultCount / resultsPerPage);
            var limit = maxPages ? Math.min(count, maxPages) : count;
            setPageCount(limit);
        }
    }, []);
    /**
     * useGoogleCloudSearch hook
     * Pass in the above interceptSearchRequest and interceptSearchResponse callbacks
     */
    var _k = (0, use_google_search_1.useGoogleCloudSearch)({
        clientId: gapiClientId,
        googleSearchApplicationId: googleSearchApplicationId,
        interceptSearchRequest: interceptSearchRequest,
        interceptSearchResponse: interceptSearchResponse,
        isGapiLoaded: isGapiLoaded,
        searchInputId: GOOGLE_SEARCH_SEARCH_INPUT,
    }), hiddenAnchors = _k[0], resultsContainer = _k[1];
    /**
     * handlePageClick
     * Pagination. Fire request for new page.
     */
    var handlePaginationClick = (0, react_1.useCallback)(function (_a) {
        var selectedPage = _a.selected;
        var newOffset = Math.ceil(selectedPage * resultsPerPage);
        if (resultsContainer) {
            var currentRequest = resultsContainer.getCurrentRequest();
            resultsContainer.executeRequest(__assign(__assign({}, currentRequest), { start: newOffset }));
        }
        setPage(selectedPage);
    }, [resultsContainer, resultsPerPage]);
    /**
     * useEffect - SEARCH
     * listen for change of currentQuery and
     * call debouncedSearch or search callbacks
     */
    var search = (0, react_1.useCallback)(function (resultsContainerInstance, query) {
        var fireSearch = function () {
            if (resultsContainerInstance) {
                resultsContainerInstance.executeRequest({
                    // This is a somewhat hacky way to avoid 400 errors for providing an empty query and
                    // also gets the toggle to work when switching from my clients to all clients.
                    query: query || ' ',
                    pageSize: resultsPerPage,
                    requestOptions: {
                        searchApplicationId: "searchapplications/".concat(googleSearchApplicationId),
                    },
                });
            }
        };
        if (initialRenderCompleted) {
            fireSearch();
        }
        else {
            // TODO (Chentai): It seems the bindings aren't fully initialized for a while after the first render,
            // this delay is there to ensure the search call on the first render succeeds. There is
            // probably a binding we can listen to but is hard to find what that is.
            setTimeout(function () { return fireSearch(); }, 1000);
            setInitialRenderCompleted(true);
        }
    }, [initialRenderCompleted, googleSearchApplicationId, resultsPerPage]);
    var debouncedSearch = (0, core_ui_1.useDebouncedCallback)(search, DEBOUNCE_MS);
    (0, react_1.useEffect)(function () {
        if (!resultsContainer)
            return;
        if (debouncedSearch) {
            debouncedSearch(resultsContainer, currentQuery);
        }
        else {
            search(resultsContainer, currentQuery);
        }
    }, [debouncedSearch, resultsContainer, search, currentQuery]);
    /**
     * useEffect - ASSOCIATIONS
     * listen for changes of searchResults and fetch associations
     */
    (0, react_1.useEffect)(function () {
        if (searchResults && !fetchedAssociations) {
            // exclude the current domainObject
            var exclusion = domainObjectReference;
            var associationsMap = (0, google_search_fetch_associations_map_1.fetchAssociationsMap)(searchResults, filesApi, exclusion);
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            associationsMap.then(function (data) {
                var enrichedSearchResults = (0, enrich_file_results_with_associations_1.enrichResultsWithAssociations)(searchResults, data);
                setSearchResults(enrichedSearchResults);
                setFetchedAssociations(true);
            });
        }
    }, [searchResults, fetchedAssociations]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_ui_1.Flexbox, { justifyContent: "center" },
            react_1.default.createElement("div", { id: "search_container", ref: searchContainerRef },
                react_1.default.createElement(StyledTopNavSearchInput, { type: "text", id: GOOGLE_SEARCH_SEARCH_INPUT, placeholder: "Search for files...", onChange: function () {
                        var _a;
                        setCurrentQuery(((_a = searchInputRef.current) === null || _a === void 0 ? void 0 : _a.value) || '');
                    }, value: currentQuery, ref: searchInputRef, disabled: !currentQuery && !searchResults }))),
        react_1.default.createElement(core_ui_1.Spacing, { height: 32 }),
        react_1.default.createElement(file_table_1.FileTable, { documentTypes: documentTypeValues, files: searchResults, fileStatus: fileStatus, hideSearchFilter: true, limit: resultsPerPage, loading: !currentQuery && !searchResults, onViewDetailsSheetChange: handleFileDetailsChange, uploadRoute: uploadRoute }),
        react_1.default.createElement(search_pagination_1.SearchPagination, { handlePageClick: handlePaginationClick, page: page, pageCount: pageCount, maxPages: maxPages }),
        hiddenAnchors));
}
exports.GoogleSearchFileTable = GoogleSearchFileTable;
// eslint-disable-next-line @typescript-eslint/naming-convention
var StyledTopNavSearchInput = styled_components_1.default.input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 550px;\n  height: 44px;\n  padding: 6px 12px;\n  font-size: 14px;\n  font-family: 'Open Sans';\n  color: ", ";\n  border-radius: 6px;\n  border: 1px solid #dbdbdb;\n\n  &:focus {\n    outline: none;\n    border-color: ", ";\n    box-shadow: 0 0 0 3px ", "20;\n  }\n\n  &:disabled {\n    border-color: rgb(219, 219, 219, 0.5);\n  }\n"], ["\n  width: 550px;\n  height: 44px;\n  padding: 6px 12px;\n  font-size: 14px;\n  font-family: 'Open Sans';\n  color: ", ";\n  border-radius: 6px;\n  border: 1px solid #dbdbdb;\n\n  &:focus {\n    outline: none;\n    border-color: ", ";\n    box-shadow: 0 0 0 3px ", "20;\n  }\n\n  &:disabled {\n    border-color: rgb(219, 219, 219, 0.5);\n  }\n"])), core_ui_1.colors.steel[500], core_ui_1.colors.brand[400], core_ui_1.colors.brand[400]);
var templateObject_1;
